const Genero = [
  { id: 1, nombre: "Unisex" },
  { id: 2, nombre: "Hombre" },
  { id: 3, nombre: "Mujer" },
];

const TipoEntrega = {};
TipoEntrega.Local = 1;
TipoEntrega.Foranea = 2;

const EstadoBodega = {};
EstadoBodega.EnProceso = 1;
EstadoBodega.Apartado = 2;
EstadoBodega.Surtido = 3;

const EstadoOrden = {};
EstadoOrden.EnProceso = 1;
EstadoOrden.ListoParaRecoger = 2;
EstadoOrden.ListoParaEntrega = 3;
EstadoOrden.Completado = 4;

const CategoriasProducto = [
  {
    id: "gid://shopify/TaxonomyCategory/hb-3-2-8",
    "full-path":
      "Salud y belleza > Cuidado personal > Cosméticos > Perfumes y colonias",
    nombre: "Perfumes y colonias",
  },
  {
    id: "gid://shopify/TaxonomyCategory/hb-3-2-8-1",
    "full-path":
      "Salud y belleza > Cuidado personal > Cosméticos > Perfumes y colonias > Brumas corporales",
    nombre: "Brumas corporales",
  },
  {
    id: "gid://shopify/TaxonomyCategory/hb-3-2-8-2",
    "full-path":
      "Salud y belleza > Cuidado personal > Cosméticos > Perfumes y colonias > Colonias",
    nombre: "Colonias",
  },
  {
    id: "gid://shopify/TaxonomyCategory/hb-3-2-8-4",
    "full-path":
      "Salud y belleza > Cuidado personal > Cosméticos > Perfumes y colonias > Aguas de colonia",
    nombre: "Aguas de colonia",
  },
  {
    id: "gid://shopify/TaxonomyCategory/hb-3-2-8-3",
    "full-path":
      "Salud y belleza > Cuidado personal > Cosméticos > Perfumes y colonias > Aguas de perfume",
    nombre: "Aguas de perfume",
  },
];

// Define different "types" of Cobranza Items
const ConciliacionItemType = { COBRANZA: 1, INTERES: 2 };
/*const loginEvent = { type: 'COBRANZA', userId: 'usr_123' };
const checkoutEvent = { type: 'INTEREST', amount: 99.99, items: 3 };
*/

export {
  Genero,
  CategoriasProducto,
  EstadoBodega,
  TipoEntrega,
  EstadoOrden,
  ConciliacionItemType,
};
